import { styled } from 'styled-components';

import type { CardProps } from './types';

type ContainerProps = Required<Pick<CardProps, 'px' | 'py'>>;

const Container = styled.div<ContainerProps>`
  background-color: ${({ theme }) => theme.colors.body.background};
  border-radius: ${({ theme }) => theme.designTokens.cardRadius};
  box-shadow: ${({ theme }) => theme.designTokens.cardShadow};
  display: inline-block;
  padding: ${({ theme, py }) => theme.space.component.y[py]} ${({ theme, px }) => theme.space.component.x[px]};
`;

export const Styled = {
  Container,
};
